import { useQuery } from '@tanstack/react-query';
import {
  fetchCommentAliases,
  normalizeAlias,
  AuthorAlias,
} from '../../services/comment-aliases';
import { usePatronSelector } from '../use-patron-selector';
import { Feature, getFeatureFlag } from '../../models/features/features';

export const COMMENT_ALIASES_QUERY_KEY = ['commentAliases'];

export const useCommentAliasesQuery = () => {
  const commentAliasEnabled = usePatronSelector((state) =>
    getFeatureFlag(state, Feature.COMMENT_ALIAS_ENABLED)
  );

  const query = useQuery<AuthorAlias[], Error>({
    queryKey: COMMENT_ALIASES_QUERY_KEY,
    queryFn: async () => {
      const response = await fetchCommentAliases();
      return response.data.data.map(normalizeAlias);
    },
    enabled: !!commentAliasEnabled,
    staleTime: 5 * 60 * 1000,
  });

  return {
    ...query,
    aliases: query.data ?? [],
    hasAliases: (query.data?.length ?? 0) > 0,
  };
};
